// import { AuthService } from './auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { SessionHandlerService } from '../services/sessionHandler.service';
import { SsoService } from '../services/sso.service';
import { CommonConstants } from './commonConstants';
import { CookieHandlerService } from '../services/cookieHandler.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  public fedToken: string;
  public key: string;
  public moAccessToken: string;

  constructor(
    private ssoService: SsoService,
    private _sessionHandlerService: SessionHandlerService,
    private _cookieHandler : CookieHandlerService,
    private router: Router
  ) { }

  /* Auth guard scope */
  // Async operations to be performed here
  // 1. Read URL params (fed token) and ecrypted key (Mobile number|First name|Last name)
  // 2. Validate fed token () - isFedTokenValid
  // if valid then resume below steps else navigate to insurance mall journey
  // 3. Register API to be called - retrieve customer token, save it session/cookie, save flag for SSO in session - customerTokenReceived
  // if (isFedTokenValid && customerTokenReceived) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  /* Auth guard scope */

  /* Vehicle registration component scope */
  // 4. Navigate to GetQoute page
  // 5. On ngInit Check SSO session flag
  // 6. If SSO session flag is true Call Demog API and prefill data on get quote page - On get quote page else resume journey normally
  /* Vehicle registration component scope */

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

    return new Promise<boolean>((resolve, reject) => {
      // Identify if it's a web journey then proceed below code, else return true
      this.fedToken = route.queryParams['token'];
      this.key = encodeURI(route.queryParams['key']) || '';
      this.moAccessToken = this._cookieHandler.GetCookie(CommonConstants.CookieKeys.accessToken);
      const isMobile = route.queryParams[CommonConstants.QueryParamsKeys.IsMobile] === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp';
      if((this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.ssoEnabled) === 'true' || this._sessionHandlerService.GetSession(CommonConstants.CookieKeys.miniOrangeToken) == 'true')){
        resolve(true);
      } else if (this.moAccessToken) {
        this.ssoService.horizontalLogin({
          'productCode': CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {
          const tokenObj = responseData.payload.tokens[0];
          this.ssoService.miniOrangeAccessToken(this.moAccessToken, tokenObj.token).subscribe({
            next: (res: any) => {
              console.log("accessToken res", res);
              const miniOrangeAccessToken = res?.customerAuthToken;
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, miniOrangeAccessToken);
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.miniOrangeToken, true);
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobile_number, res?.mobileNumber);
              resolve(true);
            },
            error: (err) => {
              this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.miniOrangeToken, false);
              resolve(true);
            }
          });

        });

          
      }
      else if ((isMobile || !this.fedToken )) {
        // if (isMobile) {
        this.disableSsoFlow();
        this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, false);
        resolve(true);
        return false;
      } else {
        this.ssoService.horizontalLogin({
          'productCode': CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance
        }).subscribe((responseData: ActivitiModel.MTResponse<any>) => {

          const tokenObj = responseData.payload.tokens[0];
          // const validateSsoPayload = {
          //   'federatedToken': 'eyJhbGciOiJIUzUxMiJ9.eyJtb2JpbGUiOiI4OTgyMTMxNzI4IiwiZXhwIjoxNjk2NjAwODA3LCJub25jZSI6ImQ1MDEwNWZlLWNhNjItNGVkOC04NzAzLTA2YzU0MTJiMGQwYyJ9.bf1t8Tl5UNcyK76g9IIv8_arhC4CqUvSajXkHvt8emL0FJ1cmAP70b1lMT-d_YWTy7NJ7Gc0FuL6WLyCx46gbA',
          //   'key': 'a2CJFo3Of8ePCsarrsDdJQ=='
          // };

          const validateSsoPayload = {
            'federatedToken': this.fedToken,
            'key': this.key
          };
          this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, tokenObj.token);
          this.ssoService.validateSsoToken(validateSsoPayload, (state, response) => {
            console.log('response', response, state);
            if (state == 'success') {
              if (response && (response?.status != '201')) {
                this.disableSsoFlow();
                resolve(true);
              } else {
                console.log('response', response);
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, true);
                this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobile_number, response?.payload?.mobileNumber);
                if (response?.headers) {
                  const authToken = response.headers.get('authtoken');
                  if (authToken !== null && authToken !== '') {
                    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, authToken);
                  }
                }
                resolve(true);
              }
            } else {
              this.disableSsoFlow();
              resolve(true);
            }
          });
        }, error => {
          this.disableSsoFlow();
          resolve(true);
        });
      }
    });
  }

  // async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

  //   return new Promise<boolean>((resolve, reject) => {
  //     // Identify if it's a web journey then proceed below code, else return true

  //     const productCode = CommonConstants.LOAN_PRODUCT_CODES.Motor_Insurance;
  //     console.log('Hi')
  //     this.ssoService.horizontalLogin({
  //       productCode
  //     }).subscribe((response: any) => {
  //       this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, response?.payload?.tokens[0]?.token);
  //       this.fedToken = route.queryParams['token'];
  //       const isMobile = route.queryParams[CommonConstants.QueryParamsKeys.IsMobile] === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp';
  //       // if(isMobile || !this.fedToken) {
  //       //   this.disableSsoFlow();
  //       //   resolve(true);
  //       // } else {
  //       // this.fedToken = next.queryParams.token;
  //       // this.ssoService.login().subscribe((response: any) => {
  //       this.fedToken = "eyJhbGciOiJIUzUxMiJ9.eyJtb2JpbGUiOiI5ODc4Nzc2Njc3IiwiZXhwIjoxNjk2NjAxMTYxLCJub25jZSI6ImFmMGE1YjQyLTViYzgtNDQ0Yy1iNGM4LWU3OGZkY2E2OWRmZSJ9.76olImp-wUJ7WoeZQzEVZ3kBf30dTc69a1HXdjPOWCb3o6RjDvNMF8sDy-HkxPr6C_CPQjERUEc1e3v60um9CA";
  //       const validateFederatedTokenPayload = {
  //         "federatedToken": this.fedToken,
  //         "key": "qhH1OZ01CZ8YS3e+Pq0zXQ=="
  //       };
  //       this.ssoService.businessServiceLogin(validateFederatedTokenPayload).subscribe((response: any) => {
  //         console.log('response', response);
  //         if (response) {
  //           if (response && response?.etbFlag) {
  //             // This API will return customer token, saving it in session
  //             this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, response?.customerAuthToken);
  //             // This is an identifier to indicate this is an SSO flow
  //             this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, true);
  //             // Mobile number needs to be passed in customerdedupe API call, so we are storing in session variable
  //             this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobileNumber, response?.mobileNumber);
  //             resolve(true);
  //           } else {
  //             this.disableSsoFlow();
  //             resolve(true);
  //           }
  //         } else {
  //           this.disableSsoFlow();
  //           resolve(true);
  //         }
  //       }, (error: any) => {
  //         this.disableSsoFlow();
  //         resolve(true);
  //       });
  //       // });
  //       // }
  //     });

  //   });
  // }

  // async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {

  //   return new Promise<boolean>((resolve, reject) => {
  //     // Identify if it's a web journey then proceed below code, else return true

  //     this.fedToken = route.queryParams['token'];
  //     const isMobile = route.queryParams[CommonConstants.QueryParamsKeys.IsMobile] === '1' || this._sessionHandlerService.GetSession('source') === 'mobileApp';
  //     if(isMobile || !this.fedToken) {
  //       this.disableSsoFlow();
  //       resolve(true);
  //     } else {
  //       // this.fedToken = next.queryParams.token;
  //     //this.ssoService.login().subscribe((response: any) => {

  //       //this.fedToken = response?.payload?.authorizationCode;
  //       const validateFederatedTokenPayload = {
  //         "authorizationCode": this.fedToken,
  //         "clientId": "Bajaj_Mall"
  //       };
  //       this.ssoService.validateFederatedToken(validateFederatedTokenPayload, this.fedToken).subscribe((response: any) => {
  //         if (response) {

  //           const encryptedValue = this.ssoService.encryptUsingAES256();
  //           const decryptedValue = this.ssoService.decryptUsingAES256();

  //           // Check if decrypted keys and validated federated token API response keys are matching or not (i.e. Mobile number, first name, last name)
  //           const keysMatching = this.validateKeyAndResponse(decryptedValue, response);
  //           if (!keysMatching) {
  //             alert('Data mismatch error');
  //             reject(false);
  //           }

  //           const registerUserPayload = {
  //             "authorizationCode": response?.payload?.tokenCode,
  //             // "authorizationCode": this.fedToken,
  //             "clientId": "Bajaj_Mall",
  //             "preRegisterRequest": {
  //               // "customerReferenceID": "",
  //               "customerType": Number(response?.payload?.customerFlag),
  //               "dateOfBirth": this.formatter.toISODateFormat(response?.payload?.dateOfBirth),
  //               // "deviceDetails": response?.payload?.deviceDetails || null,
  //               // "emailId": response?.payload?.emailId || "",
  //               "firstName": response?.payload?.firstName || null,
  //               "lastName": response?.payload?.lastName || null,
  //               // "latitude": response?.payload?.latitude || null,
  //               // "longitude": response?.payload?.longitude || null,
  //               // "middleName": response?.payload?.middleName || null,
  //               "mobileNumber": response?.payload?.mobile || null,
  //               // "pincode": response?.payload?.pincode || null,
  //               // "source": response?.payload?.source || null,
  //               // "termsAndConditions": true,
  //               // "utmCampaign": response?.payload?.utmCampaign || null,
  //               // "utmContent": response?.payload?.utmContent || null,
  //               // "utmMedium": response?.payload?.utmMedium || null,
  //               // "utmSource": response?.payload?.utmSource || null,
  //               // "utmTerm": response?.payload?.utmTerm || null,
  //               // "whatsappUpdates": true
  //             }
  //           }
  //           this.ssoService.registerUser(registerUserPayload).subscribe((response: any) => {
  //             //Trigger SSO flow only for ETB customers
  //             if (response && response?.preRegisterResponse?.customerType == 'ETB') {
  //               // This API will return customer token, saving it in session
  //               this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.JWToken, response?.customerAuthToken);
  //               // This is an identifier to indicate this is an SSO flow
  //               this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, true);
  //               // Mobile number needs to be passed in customerdedupe API call, so we are storing in session variable
  //               this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.mobileNumber, response?.preRegisterResponse?.mobileNumber);
  //               resolve(true);
  //             } else {
  //               this.disableSsoFlow();
  //               resolve(true);
  //             }
  //           }, (error: any) => {
  //             this.disableSsoFlow();
  //             alert('SSO register API error');
  //           })
  //         } else {
  //           this.navigateToBajajInsurance();  
  //         }
  //       }, (error: any) => {
  //         this.navigateToBajajInsurance();
  //       });
  //     }
  //   });
  // }

  validateKeyAndResponse(decryptedValue: string, responseObject: any) {
    const decryptedValuesArray = decryptedValue.toString().replace('"', '').replace('"', '').split("|");
    if (decryptedValuesArray[0] === responseObject?.payload?.mobile &&
      decryptedValuesArray[1] === responseObject?.payload?.firstName &&
      decryptedValuesArray[2] === responseObject?.payload?.lastName) {
      return true;
    } else {
      return false;
    }
  }

  navigateToBajajInsurance() {
    window.location.href = 'https://www.bajajfinserv.in/insurance/';
  }

  disableSsoFlow() {
    this._sessionHandlerService.SetSession(CommonConstants.CookieKeys.ssoEnabled, false);
  }

  removeQueryParams() {
    this.router.navigate(
      [],
      {
        queryParams: {
          token: null,   // Remove token query param
          key: null, // Remove key query param
        },
        queryParamsHandling: 'merge',
      }
    )
  }
}
